import React, {Component} from 'react';
import {connect} from 'react-redux';
import {allcustomer} from '../actions/userAction';
import _ from 'lodash';
import {Form, Input, Row, Button,Select,message,Radio,Spin,Icon} from 'antd';
import request from "superagent";
import {Dev_URL} from '../actionTypes';
import '../styles/css/App.css';
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const { TextArea } = Input;
const { Option } = Select;

class Subcategory extends Component {

    constructor(props) {
        super(props);
        // state
        this.state = {
          fileList1: "",
          iconLoading: false ,
          visible:false,
          phonenumber:[],
          loading:true
        };

    }

   
    componentWillMount()
    {
    //  componentWillMount
    this.props.allcustomer().then(res=>{
      this.setState({loading: false})
  })
    }  
    
    handleReset = () => {
      this.props.form.resetFields();
      this.setState({
        iconLoading: false,
        fileList1: ""
      });	
    }
  

    handleSubmit = (e) => {
      e.preventDefault();
     

      this.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
         if(this.state.visible === true)
         {
          var dataobj = {
            phonenumber : values.phonenumber,
            message : values.message,
            bulk : false
          }
         }
         else
         {
          dataobj = {
            phonenumber : this.state.phonenumber,
            message : values.message,
            bulk : true
          }
         }
           
            request.post(Dev_URL+'/bulksmsapi')
            .send(dataobj)
            .then((res) => {
              console.log(res.body);
              if (res.body.ReturnCode === 200) {
                console.log(res.body);
                this.setState({
                 loader: false,
                });
                this.props.form.resetFields();
                message.success('SMS Sent Successfully!');
              } 
              else 
              {
                this.setState({
                  loader: false, visible: true,
                });
                message.error('Something went wrong!');
              }
            })
            .catch((err) => {
              console.log(err);
            });

        }
      });
    }
   
    renderCategory()
    {
         return _.map(this.props.driver,(driver,key) => {
                return (
                  <Option value={driver.Customer_Mobile_Number} key={key}> 
                  {driver.Customer_Name}
                  </Option>
                );
              })
    }
    onChange = e => {
      if(e.target.value === "2")
      {
        this.setState({
          visible: true,
        });
      }
      else
      {
        this.setState({
          visible: false,
        });
      }
      
    };
   
// ======================================================

    render() {
     
      
    
      const { getFieldDecorator } = this.props.form;
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 10 },
        },
      };


//==============================================================================================================//
       
          return (
<div>
<Spin  indicator={antIcon} spinning={this.state.loading}>
            <div className="container-fluid addp">
            <div className="container-fluid">
            <div className="row">
                <div className="col-sm-4">
                    <h4>Bulk SMS Sender</h4>
                </div>
                {/* <div className="col-sm-8 text-right">
                <Link to="/subcategory"><Button className="pull-right" type="dark" icon="arrow-left">Back To Sub-Category</Button></Link>
                </div> */}
                </div>
            
            </div>
            </div>
          <div className="container-fluid text-left addproduct">
          
          <Row>
             <Form onSubmit={this.handleSubmit}>
             <Form.Item  {...formItemLayout} label="Customer Selection">
          {getFieldDecorator('radio-group',{
                    rules: [{ required: true, message: 'Select option'}],
                  })(
            <Radio.Group onChange={this.onChange}>
              <Radio value="1">All</Radio>
              <Radio value="2">Custom</Radio>
            </Radio.Group>,
          )}
        </Form.Item>
        {this.state.visible === true ? ( <Form.Item
                  {...formItemLayout}
                  label="Customer"
                >
                  {getFieldDecorator('phonenumber', {
                    rules: [{ required: true, message: 'Select Customer', type: 'array'}],
                  })(
                    <Select 
                    showSearch
                    mode="multiple"
                    placeholder="Select Customer"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    >
                    {this.renderCategory()}
                    </Select>
                  )}
                </Form.Item>):null}
               

                <Form.Item
                  {...formItemLayout}
                  label="Message"
                >
                  {getFieldDecorator('message', {
                    rules: [
                        {
                          required: true,
                          message: 'please enter message',
                        },
                        { max: 160, message: 'Message text maximum 160 characters only' }
                      ],
                  })(
                    <TextArea rows ={5} />
                  )}
                </Form.Item>
              
{/* =============================== Submit Button ======================================== */}

        <Form.Item
          wrapperCol={{ span: 12, offset: 6 }}
        >
          <Button type="primary" size="large" htmlType="submit" loading={this.state.iconLoading}>Submit</Button>
          <Button style={{ marginLeft: 15 }} size="large" onClick={this.handleReset}>
              Clear
            </Button>
        </Form.Item>
          </Form>
        
        </Row>
       
         </div>
         </Spin>
        </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
    user: state.user,
    driver: state.driver
  };
}

const WrappedRegistrationForm = Form.create()(Subcategory);

export default connect(mapStateToProps, {allcustomer})(WrappedRegistrationForm);
